export default __webpack_public_path__ + "static/media/mdi_television.e26c4b61.svg";